/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import TermsAndConditions from './TermsAndConditions';

const FullPageText = ({ children, ...props }) => {
  return (
    <div
      css={css`
        padding: 10px;
      `}
    >
      {children}

      <TermsAndConditions />
    </div>
  );
};

export default FullPageText;
